import { storeToRefs } from 'pinia'
import { useAppStore } from '@/stores/app.store'

interface ISlugs {
  [locale: string]: string
}

export const useHreflang = () => {
  const config = useRuntimeConfig()
  const appStore = useAppStore()
  const { availableLocales, slugs } = storeToRefs(appStore)

  const buildLocalizedUrl = (localeCode: string, slugs: ISlugs) => {
    const baseUrl = config.public.baseUrl
    const trimmedSlug = slugs[localeCode]?.replace(/^\//, '')

    return `${baseUrl}/${trimmedSlug}`
  }

  const hreflangs = computed(() => {
    const hreflangs = availableLocales.value
      .filter((loc: string) => slugs.value[loc])
      .map((loc: string) => ({
        rel: 'alternate',
        hreflang: loc,
        href: buildLocalizedUrl(loc, slugs.value)
      }))

    const englishSlugAvailable = slugs.value.en !== undefined
    const fallbackLocale = englishSlugAvailable ? 'en' : availableLocales.value.find((loc: string) => slugs.value[loc])

    if (fallbackLocale) {
      hreflangs.push({
        rel: 'alternate',
        hreflang: 'x-default',
        href: buildLocalizedUrl(fallbackLocale, slugs.value)
      })
    }

    return hreflangs
  })

  return { hreflangs }
}
